import React, {PureComponent, Fragment} from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@adsk/bim360-matrix-react-tooltip';
import {StatusColorIndicator} from '@adsk/bim360-matrix-react-status-color-indicator';
import isContentOverflowingElement from '@adsk/bim360-matrix-react-helpers/es/isContentOverflowingElement';
import {statusColorMapping} from '../../constants/status-types';
import i18n from '../../utils/i18n';

class ProjectListTableStatusCell extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      shouldShow: false,
      isTruncated: false
    };

    this._setTextContainerRef = this._setTextContainerRef.bind(this);
    this._handleMouseEnter = this._handleMouseEnter.bind(this);
    this._handleMouseLeave = this._handleMouseLeave.bind(this);
  }

  componentWillUnmount() {
    this._clearShowTimer();
    this._clearHideTimer();
  }

  _clearShowTimer() {
    if (this.showTimer) {
      clearTimeout(this.showTimer);
      delete this.showTimer;
    }
  }

  _clearHideTimer() {
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      delete this.hideTimer;
    }
  }

  _setTextContainerRef(ref) {
    this.textContainer = ref;
  }

  _handleMouseEnter() {
    if (this._mouseHovering) {
      return;
    }
    this._mouseHovering = true;

    this._clearHideTimer();

    this.showTimer = setTimeout(() => {
      this.setState({
        shouldShow: true,
        isTruncated: this.textContainer && isContentOverflowingElement(this.textContainer)
      });
      delete this.showTimer;
    }, 100);
  }

  _handleMouseLeave() {
    this._mouseHovering = false;

    this._clearShowTimer();

    this.hideTimer = setTimeout(() => {
      this.setState({
        shouldShow: false
      });
      delete this.hideTimer;
    }, 100);
  }

  renderStatusText(cellData) {
    return i18n.t(`status.${cellData}`);
  }

  renderChildren(cellData) {
    return (
      <Fragment>
        <StatusColorIndicator
          statusColor={statusColorMapping[cellData]}
          className="ProjectListTableStatusCell__indicator"
          data-testid="ProjectListTableStatusCell__indicator"
        />
        {this.props.showFull && (
          <span
            className="ProjectListTableStatusCell__text"
            data-testid="ProjectListTableStatusCell__text"
            ref={this._setTextContainerRef}
          >
            {this.renderStatusText(cellData)}
          </span>
        )}
      </Fragment>
    );
  }

  render() {
    const {container, showFull, cellData} = this.props;
    const {shouldShow, isTruncated} = this.state;
    // Here we check if the cell itself truncated when it's in fully shown in width
    const showTooltip = shouldShow && ((showFull && isTruncated) || !showFull);
    const tooltipClassName = `ProjectListTableStatusCell__popover ProjectListTableStatusCell__popover--${cellData}`;

    return (
      <div
        className="ProjectListTableStatusCell"
        onMouseEnter={this._handleMouseEnter}
        onMouseLeave={this._handleMouseLeave}
      >
        <Tooltip
          place={Tooltip.Places.RIGHT}
          tooltipClassName={tooltipClassName}
          show={showTooltip}
          content={this.renderStatusText(cellData)}
          container={container}
        >
          {this.renderChildren(cellData)}
        </Tooltip>
      </div>
    );
  }
}

ProjectListTableStatusCell.displayName = 'ProjectListTableStatusCell';

ProjectListTableStatusCell.propTypes = {
  cellData: PropTypes.string.isRequired,
  showFull: PropTypes.bool,
  container: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
};

export default ProjectListTableStatusCell;
